export const styleColumn={
paddingColumnStart:"15px 5px 15px 24px",
paddingColumnEnd:"15px 24px 15px 5px"
}